import { io, Socket } from 'socket.io-client'
import { WS_API_URL } from '../../config'

class SocketServices {
  socket: Socket

  private onConnect() {
    console.debug('SocketServices connected')
  }

  private onDisconnect(reason: Socket.DisconnectReason, description?: any) {
    console.debug('SocketServices disconnected', {
      reason,
      description,
    })
  }

  private onConnectError(err: Error) {
    console.debug('SocketServices connection error', {
      err,
    })
  }

  constructor(url?: string) {
    console.debug('SocketServices constructor', url)
    if (!url) {
      throw new Error('init server before emit a message')
    }
    this.socket = io(url, {
      transports: ['websocket'],
    })

    this.socket.on('connect', this.onConnect)
    this.socket.on('disconnect', this.onDisconnect)
    this.socket.on('connect_error', this.onConnectError)
  }

  connectTo<TMessage = any>(connection: string, listener: (message: TMessage) => void) {
    this.socket?.on?.(connection, listener)
  }

  disconnectTo(connection: string) {
    this.socket?.off?.(connection)
  }

  emit<TMessage = any>(connection: string, message: TMessage) {
    this.socket?.emit(connection, message)
  }
}

export const socketSingleton = new SocketServices(WS_API_URL)
